/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Directive, ElementRef, EventEmitter, Output, Self } from '@angular/core';
import { MatSelect } from '@angular/material/select';

@Directive({
	selector: '[appPreventEnter]',
	standalone: false,
})
export class PreventEnterDirective {
	@Output('enterkeydown') enterkeydown: EventEmitter<any> = new EventEmitter<any>();

	constructor(@Self() private select: MatSelect, private el: ElementRef) {
		this.select._handleKeydown = (event: KeyboardEvent) => {
			if (event.key === 'Enter') {
				const active = this.select.panelOpen ? this.select.options.filter((x) => x.active)[0] || null : null;
				this.select.close();
				this.enterkeydown.emit(active ? active.value : null);
			} else {
				if (!this.select.disabled) {
					this.select.panelOpen ? (this.select as any)._handleOpenKeydown(event) : (this.select as any)._handleClosedKeydown(event);
				}
			}
		};
	}
}
